// extracted by mini-css-extract-plugin
module.exports = {"Title":"style_Title__3aFIB","Row":"style_Row__2Snmp","Info":"style_Info__1LxoK","SubInfo":"style_SubInfo__1noJz"};